// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    name: 'dev',
    production: false,
    awsS3BucketUrl: "https://leanon-dev-bucket.s3.amazonaws.com",
    firebaseConfig: {
        apiKey: "AIzaSyDP-HSbyOlAdJKTXCsZhaZbUmgOoaK21yw",
        authDomain: "lean-on-cms-notifications.firebaseapp.com",
        projectId: "lean-on-cms-notifications",
        storageBucket: "lean-on-cms-notifications.firebasestorage.app",
        messagingSenderId: "716732019866",
        appId: "1:716732019866:web:cbe66480d0a13a3458db23",
        measurementId: "G-FT000D9TN2"
    },
    // Firebase Console → lean-on-cms-notifications → Project settings → Cloud Messaging → Web Push certificates
    firebaseVapidKey: 'BHWaCv0cs2HZPHkTagdBz2luaYO2moGamFc3pbzGqCU-we3JRH9qyrNRs06Chl9vKw6Snx4Vv09GUGgFn0BZKok',
    giphyApiKey: "aDvue9qYMy1FOCU77QN6cvodRLH8Wrbb" // Replace with your Giphy API key from https://developers.giphy.com/
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
